import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMapMarker, faBars, faExternalLinkAlt, faUpload } from '@fortawesome/free-solid-svg-icons'
import { faFile, faFileAlt, faImage } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faBars)
library.add(faMapMarker)
library.add(faExternalLinkAlt)
library.add(faUpload)
library.add(faFile)
library.add(faFileAlt)
library.add(faImage)

Vue.component('font-awesome-icon', FontAwesomeIcon)
